module.exports = __webpack_public_path__ + "img/signal-strong.ce1c86d0.svg";